// extracted by mini-css-extract-plugin
export default {"vk":"vk","vk_content":"vk_content","vk_empty_row":"vk_empty_row"};